export const DEFAULT_TERMS_DOCUMENT_PATH = '/terms-and-conditions';
